export default __webpack_public_path__ + "static/media/322030_2_0.63af79ce.eot";